import {
  fetchResearchProjectQuery,
  fetchPublicationQuery,
  fetchAwardQuery,
  fetchCooperationQuery,
  fetchEventQuery,
  fetchStaffQuery,
  fetchLeurisProfileQuery
} from '@/graphql'

import { ListSchema } from '@/schema/list'

export default {
  loading: false,
  showOrgaTree: true,
  selected: {
    id: null,
    type: null,
    rootQueryType: null,
    typeLabel: null
  },
  leurisProfile: {
    data: null,
    query: fetchLeurisProfileQuery,
    orcid: null,
    ulWebsiteProfile: {
      de: null,
      en: null
    }
  },
  ouDetails: {
    stringRep: null,
    begin: null,
    end: null,
    description: null
  },
  staff: {
    loading: false,
    startsWith: null,
    fullName: null,
    letterCount: {},
    pageSize: 500,
    page: 1,
    data: [],
    totalEntries: 0,
    query: fetchStaffQuery
  },
  data: {
    forschungsprojekt: [],
    kooperation: [],
    publikation: [],
    veranstaltung: [],
    preis: []
  },
  id: null,
  total: {
    forschungsprojekt: 0,
    kooperation: 0,
    publikation: 0,
    veranstaltung: 0,
    preis: 0
  },
  activeTab: 0,
  label: null,
  resourceType: 'forschungsprojekt',
  resourceTypes: [{
    type: 'forschungsprojekt',
    label: 'Projekte',
    query: fetchResearchProjectQuery
  },
  {
    type: 'publikation',
    label: 'Publikationen',
    query: fetchPublicationQuery
  },
  {
    type: 'preis',
    label: 'Preise',
    query: fetchAwardQuery
  },
  {
    type: 'kooperation',
    label: 'Kooperationen',
    query: fetchCooperationQuery
  },
  {
    type: 'veranstaltung',
    label: 'Veranstaltungen',
    query: fetchEventQuery
  }],
  listSchema: ListSchema,
  filter: {
    forschungsprojekt: {
      filter: {},
      filters: [
        { type: 'input', value: 'year', label: 'Public.filter.jahr', icon: 'calendar', style: { width: '90px' } },
        { type: 'select', value: 'status', label: 'Public.filter.status', options: ['ONGOING', 'TERMINATED'] },
        { type: 'input', value: 'funding', label: 'Public.filter.mittelgeber', icon: 'credit-card' },
        { type: 'input', value: 'person', label: 'Public.filter.person', icon: 'user' },
        { type: 'input', value: 'freetext', label: 'Public.filter.suche', icon: 'align-left' },
        { type: 'select', value: 'sdg', label: 'Public.filter.sdg', icon: 'bullseye', hidden: true },
      ]
    },
    kooperation: {
      filter: {},
      filters: [
        { type: 'input', value: 'year', label: 'Public.filter.jahr', icon: 'calendar', style: { width: '90px' } },
        { type: 'input', value: 'person', label: 'Public.filter.person', icon: 'user' },
        { type: 'input', value: 'externalPartner', label: 'Public.filter.externalPartner', icon: 'globe' },
        { type: 'input', value: 'freetext', label: 'Public.filter.suche', icon: 'align-left' }
      ]
    },
    publikation: {
      filter: {},
      filters: [
        { type: 'input', value: 'year', label: 'Public.filter.jahr', icon: 'calendar', style: { width: '90px' } },
        { type: 'select', value: 'category', label: 'Public.filter.publikationstypen', options: ['ARTICLE', 'MONOGRAPHY', 'EDITORSHIP', 'CONTRIBUTION', 'REPORT'] },
        { type: 'input', value: 'person', label: 'Public.filter.person', icon: 'user' },
        { type: 'input', value: 'freetext', label: 'Public.filter.suche', icon: 'align-left' },
        // this is only here to get a translation for the print view (see PublicListOptions)
        { type: 'other', value: 'fundedByCategory', label: 'Public.filter.fundedByPrintLabel', icon: 'credit-card' }
      ]
    },
    veranstaltung: {
      filter: {},
      filters: [
        { type: 'input', value: 'year', label: 'Public.filter.jahr', icon: 'calendar', style: { width: '90px' } },
        { type: 'input', value: 'person', label: 'Public.filter.person', icon: 'user' },
        { type: 'input', value: 'freetext', label: 'Public.filter.suche', icon: 'align-left' }
      ]
    },
    preis: {
      filter: {},
      filters: [
        { type: 'input', value: 'year', label: 'Public.filter.jahr', icon: 'calendar', style: { width: '90px' } },
        { type: 'input', value: 'person', label: 'Public.filter.person', icon: 'user' },
        { type: 'input', value: 'freetext', label: 'Public.filter.suche', icon: 'align-left' },
        // this is only here to get a translation for the print view (see PublicListOptions)
        { type: 'select', value: 'typeIds', label: 'Public.filter.awardsTypePrintLabel', icon: 'graduation-cap', hidden: true },
      ]
    }
  },
  config: {
    forschungsprojekt: {
      page: 1,
      perPage: 10,
      sortField: 'START_DATE',
      sortFields: [
        // { field: 'TITLE_DE', label: 'Public.sort.titel', locale: 'de' },
        // { field: 'TITLE_EN', label: 'Public.sort.titel', locale: 'en' },
        { field: 'START_DATE', label: 'Public.sort.beginn' }
      ],
      sortOrder: 'DESC'
    },
    kooperation: {
      page: 1,
      perPage: 10,
      sortField: 'START_DATE',
      sortFields: [
        // { field: 'TITLE', label: 'Public.sort.titel' },
        { field: 'START_DATE', label: 'Public.sort.beginn' }
      ],
      sortOrder: 'DESC'
    },
    publikation: {
      page: 1,
      perPage: 10,
      sortField: 'YEAR',
      sortFields: [
        { field: 'TYPE', label: 'Public.sort.typ' },
        // { field: 'TITLE', label: 'Public.sort.titel' },
        { field: 'YEAR', label: 'Public.sort.jahr' }
      ],
      sortOrder: 'DESC'
    },
    veranstaltung: {
      page: 1,
      perPage: 10,
      sortField: 'START_DATE',
      sortFields: [
        { field: 'TYPE', label: 'Public.sort.typ' },
        { field: 'START_DATE', label: 'Public.sort.beginn' }
        // { field: 'NAME', label: 'Public.sort.name' }
      ],
      sortOrder: 'DESC'
    },
    preis: {
      page: 1,
      perPage: 10,
      sortField: 'YEAR',
      sortFields: [
        { field: 'TYPE', label: 'Public.sort.typ' },
        { field: 'YEAR', label: 'Public.sort.jahr' },
        { field: 'AWARDEE', label: 'Public.sort.preisTraeger' }
        // { field: 'NAME', label: 'Public.sort.name' }
      ],
      sortOrder: 'DESC'
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/publicView/state.js